import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  SVGIcon,
  Menu as MenuComponent,
  MenuList as MenuListComponent,
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

export const ContentWrapper = styled.div`
  padding: 0 40px;
  color: ${(props) => props.theme['color.text.light']};
`;

const CohortIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 34px;
  margin-right: 15px;
`;

export const CohortIcon = () => (
  <CohortIconContainer>
    <SVGIcon
      primary
      icon="duotoneClass"
      viewBox="0 0 24 24"
      width={{ width: '24px', height: '24px' }}
    />
  </CohortIconContainer>
);

export const CohortColumnItem = styled.div`
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  line-height: 18px;
  font-size: 14px;
  word-break: normal;

  ${(props) => props.instructors && `
    position: relative;
    top: -2px;
    left: -10px;
    flex: 1 0 auto;
  `}
`;

export const EmptyStateWrapper = styled.div `
  padding-top: 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const EmptyStateImageWrapper = styled.div`
  background-image: url(${(props) => props.theme.backgroundImage});
  width: 481px;
  height: 392px;
  background-size: cover;
`;

export const MessageTitle = styled.span`
  margin-top: -19px;
  font-size: 32px;
  color: ${(props) => props.theme.titleTextColor};
`;

export const MessageBody = styled.span`
  font-size: 18px;
  color: ${(props) => props.theme.messageTextColor};
  text-align: center;
  margin-bottom: 15px;
`;

export const EmptyStateFooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 288px;
`;

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
`;

export const MenuFilter = styled(MenuComponent)`
  height: auto;
  ${(props) => !props.isViewFilterOpen && `
    background-color: transparent;
    box-shadow: none;
  `}
`;

export const MenuListFilter = styled(MenuListComponent)`
  transform: translate3d(${(props) => props.status === 'entered' ? 0 : props.direction * 100}%, 0, 0);
  opacity: ${(props) => props.status === 'entered' ? 1 : 0};
  transition: transform 0.3s;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
`;

export const LinkWrapper = styled.div`
  font-size: 16px;
  line-height: 19px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 131px;
  ${'button'} {
    background-color: #0073CA;
    border-color: #0073CA;
  }
`;

export const CohortSearchClear = styled(Button)`
  margin: 0;
  padding: 0;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  justify-self: center;
  grid-column: 2;
  grid-row: 1;
  cursor: pointer;
`;

export const CohortsSearch = styled.div`
  padding: 0 1px 16px;
  width: 200px;
  display: grid;
  grid-template-columns: 1fr 40px;

  > div {
    width: 100%;
    grid-column: 1 / span 2;
    grid-row: 1;
  }
`;
export const GreyButton = ({ iconName, ...rest }) => (
  <Button iconOnly grey height={34} {...rest}>
    <MaterialIcon id={iconName} />
  </Button>
);

GreyButton.propTypes = {
  iconName: PropTypes.string.isRequired,
};

export const PageActionsLeftFlex = styled.div`
  margin-right: auto;
  display:flex;
`;
export const FilterContainer = styled.div`
  cursor: pointer;
  width: 50px;
  height: 50px;
  margin-left: 10px;
  margin-top: ${(props) => props.isViewFilterOpen ? '0' : '-10'}px;
  position: relative;
  z-index: 1;
`;
export const SortButton = styled(
  ({ sort, id, ...rest }) => {
    let order = id === 'name' ? 'asc' : 'desc';
    if (id === sort?.key) {
      order = sort.order;
    }    
    return (<GreyButton iconName={order === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down'} {...rest} />);
  },
)`
      margin-left: 5px;
    `;